export default {
  $schema: 'https://cdn.witkac.pl/jschema/latest/WitkacJsonSchema.json',
  $options: {
    validationMessages: {
      required: 'Proszę uzupełnić pole'
    }
  }
};
